{
  const BaseModule = require('_base/base')

  class AnimatedSlaveModule extends BaseModule {
    postInit() {
      this.$master = this.$spread.find(this.$el.data('master'))

      this.bindEvents()
    }

    bindEvents() {
      this.$master.on('positionUpdated', (_, coords) => {
        requestAnimationFrame(() => this._draw(coords))
      })
    }

    _draw(coords) {
      this.$el
        .css({ transform: `translate(${coords.x}px, ${coords.y}px)` })
    }
  }

  $('.js__animatedSlave').each(function() {
    new AnimatedSlaveModule($(this))
  })
}
